module.exports = __webpack_public_path__ + "static/media/Recomposition_02@2x.edbe53ed.png";